import useAnswerSideBarStore, {
  AnswerSideBarItem,
} from "@/stores/answer-side-bar";
import type { KbCitationTab, KbContentData } from "@/utils/knowledge-content";

/*
 * AnswerSideBarItem[] 배열에서 id를 추출해, 정렬 하는 함수
 * 같은 출처 버튼을 다시 눌렀을 때 토글로 닫고, 현재 열린 출처가 무엇인지 판별하기 위함
*/
const sourceKeyFrom = (refs: AnswerSideBarItem[]) =>
  refs
    .map((r) => r.id)
    .sort((a, b) => a - b)
    .join(",");

const useAnswerSideBar = () => {
  const {
    toggleAnswerSideBar,
    clearItems,
    setType,
    setItems,
    openAnswerSideBar,
    setSelectedReferenceNumber,
    setIsKb,
    setKnowledgeContent,
    setCitationTab,
    isOpen,
    selectedReferenceNumber,
  } = useAnswerSideBarStore();

  const handleAnswerSideBarOpen = (
    type: "answer-reference" | "paper-titles",
    reference: AnswerSideBarItem[],
    isKb = false,
    knowledgeContent: KbContentData | null = null,
    /* 웹 출처 없는 KB 전용 버튼은 키가 ""로 겹치므로 message.id 같은 고유 키를 받는다 */
    explicitKey?: string,
    /** 열자마자 보여줄 Citation 탭. 본문 [A]/[RDB] 태그가 지정한다 */
    citationTab: KbCitationTab | null = null
  ) => {
    const key =
      explicitKey ?? (type === "answer-reference" ? sourceKeyFrom(reference) : "paper-titles");
    if (isOpen && selectedReferenceNumber === key) {
      toggleAnswerSideBar();
      return;
    }

    clearItems();
    setType(type);
    setItems(reference);
    setSelectedReferenceNumber(key);
    setIsKb(isKb);
    setKnowledgeContent(knowledgeContent);
    setCitationTab(citationTab);
    openAnswerSideBar();
  };

  return {
    handleAnswerSideBarOpen,
  };
};

export default useAnswerSideBar;
